<h1 class="display-3 mb-20">Recovery Code</h1>

<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <div class="form-group">
    <label for="username" class="form-label">Recovery Code</label>
    <input [(ngModel)]="mfaCode" formControlName="mfaCode" type="text" class="form-control" placeholder="Recovery Code" required />
    <input-errors [control]="form.controls.mfaCode" [service]="validationService"></input-errors>
  </div>
  <button type="submit" class="btn btn-primary" [disabled]="!form.valid || loading">
    <ng-container *ngIf="!loading">Recover</ng-container>
    <i *ngIf="loading" class="icon icon-wait spin"></i>
  </button>
</form>

<div class="forgot-link text-center mt-20">
  <a [routerLink]="['/login']">
    Remember it? Log in
  </a>
</div>
